import React, { useReducer, useEffect, useState, useRef } from "react";
import DataGrid, {
  Column,
  Lookup,
  RequiredRule,
  Editing,
  Item,
  ColumnFixing,
  FormItem,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import * as actions from "../../../actions/dashboard";
import dashboardReducer from "../../../reducers/dashboard";
import { GRID_CONFIG, changesList, hseStatus } from "./config";
import { Toast } from "devextreme-react/toast";
import { Button } from "devextreme-react/autocomplete";
import { Popup } from "devextreme-react/popup";
import SchedulerHandler from "./SchedulerHandler";
import {
  set,
  get,
  setGridUserPrefs,
  setGridWidthPrefs,
  applyUserPref,
  saveUserPref,
} from "../../../common/utils";

const initialState = { schedules: [], userPref: null };

const EmailScheduler = ({ siteId, tierId, isEditable }) => {
  const [state, dispatch] = useReducer(dashboardReducer, initialState);

  const [isEdit, setIsEdit] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const { userPref, schedules } = state;
  const basePath = window.location.origin;
  const [activeInfo, setActiveInfo] = useState({});

  const [scrollConfig] = useState({
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  });
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "info",
    message: "",
  });

  useEffect(() => {
    actions.getSchedules(dispatch);
  }, []);

  const emailsGrid = useRef(null);

  const widgetId = "reasonCodesForAdmin";
  const GRID_COLS = JSON.stringify([
    "subject",
    "schedularDatetime",
    "timeZone",
    "status",
  ]);
  const loggedinUser = get("hid");

  useEffect(() => {
    actions.fetchUserPref(
      dispatch,
      `=0&SiteUID=${siteId ? siteId : "AdminConsole"}&widgetID=${widgetId}`
    );
    return () => {
      actions.updateUserPref(
        dispatch,
        saveUserPref({
          widgetId,
          siteId: "AdminConsole",
          tierId: 0,
          moduleName: widgetId,
          loggedinUser,
          prefSess: "userPrefSettings",
          GRID_COLS,
        })
      );
    };
  }, []);

  useEffect(() => {
    if (userPref) set("userPrefSettings", userPref);
    if (
      emailsGrid &&
      emailsGrid.current &&
      emailsGrid.current.instance !== null &&
      userPref !== null
    ) {
      applyUserPref(emailsGrid, userPref);
    }
  }, [userPref, schedules]);

  function onHiding() {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  }

  const onRowInserted = (data) => {};

  const onRowRemoved = (data) => {
    actions.delSchedule(dispatch, data.data.id);
  };

  const handlers = {
    onRowRemoved: onRowRemoved,
  };

  return (
    <>
      <>
        {!isEdit && (
          <>
            <div className="gem-fltr-adj ">
              <div className="dx-field-value-static">
                <button
                  style={{ padding: "10px 11px", cursor: "pointer" }}
                  className="dx-button-mode-contained"
                  id="link4"
                  onClick={() => {
                    setShowForm(true);
                    setIsEdit(true);
                  }}
                >
                  {" "}
                  <i className="fas fa-plus"></i>
                </button>
              </div>
            </div>

            <DataGrid
              dataSource={state.schedules}
              showBorders={true}
              {...GRID_CONFIG}
              {...handlers}
              ref={emailsGrid}
              onContentReady={(e) => setGridUserPrefs(e, widgetId)}
              onColumnsChanging={(e) => setGridWidthPrefs(e, widgetId)}
            >
              <ColumnFixing enabled={true} />
              <Paging defaultPageSize={10} />
              <Pager
                visible={true}
                allowedPageSizes={[5, 10, 20, 50]}
                showPageSizeSelector={true}
                showInfo={true}
                showNavigationButtons={true}
              />

              <Editing
                mode="popup"
                allowUpdating={isEditable}
                allowAdding={isEditable}
                allowDeleting={isEditable}
                useIcons={true}
              >
                <Popup title="MOC" showTitle={true} width={800} />
              </Editing>
              <Column
                dataField="subject"
                caption="Subject"
                dataType="string"
              ></Column>

              <Column
                dataField="schedularDatetime"
                caption="Date and Time"
                dataType="datetime"
              />
              <Column
                dataField="timeZone"
                caption="Timezone"
                dataType="string"
              />

              <Column dataField="status" caption="Status" dataType="string" />

              <Column
                fixedPosition="right"
                fixed={true}
                type="buttons"
                id="popup"
                showInColumnChooser={false}
              >
                <Button
                  name="edit"
                  onClick={(e) => {
                    setActiveInfo(e.row.data);
                    setShowForm(false);
                    setIsEdit(true);
                  }}
                ></Button>
                <Button name="delete"></Button>
              </Column>
            </DataGrid>
          </>
        )}
        {isEdit && (
          <SchedulerHandler
            isEdit={true}
            isAdd={showForm}
            closeIt={() => {
              setIsEdit(false);
              actions.getSchedules(dispatch);
            }}
            data={activeInfo}
            showTemplateEditor={true}
          />
        )}
      </>

      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={2000}
      />
    </>
  );
};

export default EmailScheduler;
